import queryString from 'query-string';

export const getRapidViewIdFromUrl = (): number =>
	queryString.parse(window.location.search).rapidView;

export const getLegacyIssueViewUrl = () => {
	const params = queryString.parse(window.location.search);
	params.oldIssueView = 'true';

	return `${window.location.protocol}//${window.location.host}${
		window.location.pathname
	}?${queryString.stringify(params)}${window.location.hash}`;
};
